const e = "styles-module__field___lgrEn", l = {
  field: e,
  "field-input": "styles-module__field-input___zXwG8",
  "vgs-collect-native-input": "styles-module__vgs-collect-native-input___aT78y",
  "vgs-collect-container__focused": "styles-module__vgs-collect-container__focused___3-ARo"
};
export {
  l as default,
  e as field
};
